<template>
    <div class="slider">
        <div @click.stop="current = !current ? images.length - 1 : current - 1" class="arrow arrow-left">
            <i class="fa fa-chevron-left"></i>
        </div>
        <div class="img" :style="{backgroundImage: `url(${images[current].path})`}"></div>
        <!--        <img :src="images[current]" alt="">-->
        <div @click.stop="current = ((current + 1) % images.length)" class="arrow arrow-right">
            <i class="fa fa-chevron-right"></i>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ImageSlider',
    props: {
        images: {
            required: true,
            type: Array
        }
    },
    data () {
        return {
            current: 0
        }
    }
}
</script>

<style scoped lang="scss">
    .slider {
        position: relative;
        height: 100%;
        min-height: 250px;

        .img {
            width: 100%;
            height: 100%;
            background-repeat: no-repeat;
            background-size: cover;
            background-position: center;
        }

        .arrow {
            position: absolute;
            top: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 50%;
            background-color: #ff9a22;
            color: #fff;
            width: 30px;
            height: 30px;
            cursor: pointer;
            transform: translate(-50%, -50%);
            z-index: 1;
        }

        .arrow-right {
            left: 100%;
        }

        .arrow-left {
        }
    }
</style>
